
import React, {Component} from 'react'
import './styles.css'

import kensho from '../../assets/kensho.svg'

class PoweredByKensho extends Component {
  render() {
    return (
      <div className="kensho">
        <div className="kensho-powered">Powered by</div>
        <img className="kensho-logo" alt="Kensho" src={kensho} />
      </div>
    )
  }
}

export default PoweredByKensho



// WEBPACK FOOTER //
// ./src/components/PoweredByKensho/index.js